const whyItWorks = () => (
    <section id="whyItWorks" class="section-padding bg-white">
        <div class="container mx-auto px-6 md:px-0 md:w-10/12 lg:w-8/12 xl:w-6/12">
            <h2 class="text-3xl font-bold text-center mb-12">Relationship-Safe and Stress-Free</h2>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div class="text-center">
                    <div class="feature-icon rounded-full p-4 inline-flex mb-4">
                        <i class="fas fa-handshake text-2xl"></i>
                    </div>
                    <h3 class="font-semibold text-lg mb-2">Polite first, firm later</h3>
                    <p class="text-gray-600">Gradual escalation protects client relationships while ensuring payment.</p>
                </div>
                <div class="text-center">
                    <div class="feature-icon rounded-full p-4 inline-flex mb-4">
                        <i class="fas fa-sliders-h text-2xl"></i>
                    </div>
                    <h3 class="font-semibold text-lg mb-2">Fully customizable</h3>
                    <p class="text-gray-600">Tailor the tone, schedule, and approach for each client segment.</p>
                </div>
                <div class="text-center">
                    <div class="feature-icon rounded-full p-4 inline-flex mb-4">
                        <i class="fas fa-exchange-alt text-2xl"></i>
                    </div>
                    <h3 class="font-semibold text-lg mb-2">Seamless integration</h3>
                    <p class="text-gray-600">Works with QuickBooks or Xero for automatic invoice tracking.</p>
                </div>
            </div>
        </div>
    </section>
);

export default whyItWorks;